import { format } from 'date-fns';
// @mui
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import LinearProgress from '@mui/material/LinearProgress';
// utils
import { fCurrency } from 'src/utils/format-number';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
// types
import { ICategortItem, professional } from 'src/types/product';
import { FormControlLabel, Switch, Table } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

// ----------------------------------------------------------------------
type Props = {
  row: professional;
  selected: boolean;
  onEditRow: VoidFunction;
  onViewRow: VoidFunction;
  onSelectRow: VoidFunction;
  onDeleteRow: VoidFunction;
  index: number;
  onUpdateStatus: VoidFunction;
};
export default function ProfessionalTable({
  index,
  row,
  onUpdateStatus,
  selected,
  onSelectRow,
  onDeleteRow,
  onEditRow,
  onViewRow,
}: Props) {
  const { user_id, username, profile_image_url, is_verified, is_approved ,name, email,created_at } = row;
  const confirm = useBoolean();
  const popover = usePopover();

  const theme = createTheme({
    components: {
      MuiSwitch: {
        styleOverrides: {
          switchBase: {
            // Controls default (unchecked) color for the thumb
            // color: "#2d9668"
            // padding: '9px 13px 9px 12px',
            // width: '58px',
            // height: '38px',
            height: '44.9px',
            marginLeft: '2.1px',
          },
          colorPrimary: {
            '&.Mui-checked': {
              // Controls checked color for the thumb
              color: '#ffffff',
            },
          },
          track: {
            // Controls default (unchecked) color for the track
            opacity: 1.7,
            borderRadius: '14px',
            height: '21.2px',
            width: '66px',
            backgroundColor: '#ff0303',
            '.Mui-checked.Mui-checked + &': {
              // Controls checked color for the track
              opacity: 1.7,
              //  width: '58px',
              height: '21.2px',
              width: '66px',
              borderRadius: '14px',

              //  height: '38px',
              backgroundColor: '#2d9668',
            },
          },
        },
      },
    },
  });
  // const rowBackgroundColor = index % 2 === 0 ? 'white' : '#f2f2f2';
  // sx={{ backgroundColor: rowBackgroundColor }}
  const originalDate = new Date(created_at);
  const month = `0${originalDate.getMonth() + 1}`.slice(-2);
  const day = `0${originalDate.getDate()}`.slice(-2);
  const year = originalDate.getFullYear().toString().slice(-2);
  const hours = originalDate.getHours();
  const minutes = originalDate.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  const formattedHours = `0${hours % 12 || 12}`.slice(-2);
  const formattedMinutes = `0${minutes}`.slice(-2);

  const formattedStartDate = `${month}/${day}/${year} ${formattedHours}:${formattedMinutes} ${ampm}`;

 const capitalizedUsername =
  name && name.trim()
    ? name.charAt(0).toUpperCase() + name.slice(1)
    : <strong>Incomplete Profile</strong>;

  return (
    <>
      {/* <TableRow hover selected={selected}> */}
      <TableRow hover  sx={{
        ':hover': {
          backgroundColor: '#d0d0d0 !important',
        },
      }} >
        {/* <TableCell padding="checkbox">{index}</TableCell> */}
        <TableCell>
          <Box sx={{ display: 'flex' }}>
            <Avatar
              // alt="I"
              src={profile_image_url}
              // variant="rounded"
              sx={{ width: 35, height: 35, mr: 2 }}
            />{' '}
            <div style={{ justifyContent: 'center', marginTop: 7 }}>{capitalizedUsername}</div>
          </Box>
        </TableCell>

        <TableCell>{email}</TableCell>

        <TableCell>{formattedStartDate}</TableCell>

        {/* <TableCell padding="checkbox">
          <Checkbox checked={is_verified} onClick={onSelectRow} />
        </TableCell> */}
        {/* <TableCell>
        <Switch checked={ loginstatus} onChange={onUpdateStatus} value={loginstatus} />
        </TableCell> */}

        <TableCell sx={{ padding: 0 }}>
          <ThemeProvider theme={theme}>
            <Switch
              sx={{ color: '#c9c9ca', width: '62px' }}
              checked={is_approved }
              onChange={onUpdateStatus}
              value={is_approved }
            />
          </ThemeProvider>
        </TableCell>
      
        {/* <TableCell align="right">
          <IconButton color={popover.open ? 'primary' : 'default'} onClick={popover.onOpen}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>  */}
      </TableRow>
      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140 }}
      >
        <MenuItem
          onClick={() => {
            onViewRow();
            popover.onClose();
          }}
        >
          <Iconify icon="solar:eye-bold" />
          Preview
        </MenuItem>
        {/* <MenuItem
          onClick={() => {
            onEditRow();
            popover.onClose();
          }}
        >
          <Iconify icon="solar:pen-bold" />
          Edit
        </MenuItem> */}
        {/* <MenuItem
          onClick={() => {
            confirm.onTrue();
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem> */}
      </CustomPopover>
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you sure want to delete?"
        action={
          <Button variant="contained" color="error" onClick={onDeleteRow}>
            Delete
          </Button>
        }
      />
    </>
  );
}
